import createIcon from '../../createIcon';

/**
 * @component @name Transform
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMThWMTZIOFY0SDEwTDcgMUw0IDRINlY2SDJWOEg2VjE2QzYgMTcuMSA2LjkgMTggOCAxOEgxNlYyMEgxNEwxNyAyM0wyMCAyMEgxOFYxOEgyMlpNMTAgOEgxNlYxNEgxOFY4QzE4IDYuOSAxNy4xIDYgMTYgNkgxMFY4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Transform = createIcon('Transform', [
  [
    'path',
    {
      d: 'M22 18V16H8V4H10L7 1L4 4H6V6H2V8H6V16C6 17.1 6.9 18 8 18H16V20H14L17 23L20 20H18V18H22ZM10 8H16V14H18V8C18 6.9 17.1 6 16 6H10V8Z',
      key: 'wlk2zy',
    },
  ],
]);

export default Transform;
